import React from 'react';
import { StarIcon } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function TestimoniosSection() {
  const testimonios = [{
    name: 'James M.',
    location: 'Austin, Texas',
    quote: "I had been stagnant in my income for years. 14 days after listening to the audio and applying the manual, I closed the biggest contract of my life. It seems like magic, but it's frequency.",
    rating: 5
  }, {
    name: 'Sarah V.',
    location: 'Denver, Colorado',
    quote: 'My relationship with money was pure stress. The 888 Code reprogrammed my anxiety. Now money flows to me in unexpected ways. Totally recommended.',
    rating: 5
  }, {
    name: 'Michael R.',
    location: 'Miami, Florida',
    quote: "I was skeptical about 'quantum programming'. But the results speak for themselves. I multiplied my income sources in less than a month. It's a ridiculous investment for what you get.",
    rating: 5
  }];
  const [headerRef, headerInView] = useInView();
  const [cardsRef, cardsInView] = useInView();
  return <section id="testimonios" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-dark relative border-t border-white/5" data-id="element-168">
      <div className="max-w-[1200px] mx-auto" data-id="element-169">
        <div ref={headerRef} className={`text-center mb-16 will-animate animate-fadeIn ${headerInView ? 'is-visible' : ''}`} data-id="element-170">
          <h2 className="font-serif text-3xl md:text-5xl font-black mb-6" data-id="element-171">
            QUANTUM <span className="text-gold" data-id="element-172">RESULTS</span>
          </h2>
          <p className="text-lg opacity-80 max-w-2xl mx-auto" data-id="element-173">
            Real people experiencing real financial transformations by tuning
            into the right frequency.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-174">
          {testimonios.map((testimonio, index) => <div key={index} className={`bg-white/5 border border-gold/10 p-8 rounded-xl relative will-animate animate-fadeIn delay-${(index + 1) * 100} ${cardsInView ? 'is-visible' : ''}`} role="article" aria-label={`Testimonial from ${testimonio.name}`} data-id="element-175">
              <div className="flex gap-1 mb-6" role="img" aria-label={`${testimonio.rating} out of 5 stars`} data-id="element-176">
                {[...Array(testimonio.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" aria-hidden="true" data-id="element-177" />)}
              </div>
              <blockquote className="opacity-95 leading-relaxed mb-8 italic" data-id="element-178">
                "{testimonio.quote}"
              </blockquote>
              <div className="flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-179">
                <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center font-bold text-gold" aria-hidden="true" data-id="element-180">
                  {testimonio.name.charAt(0)}
                </div>
                <div data-id="element-181">
                  <h4 className="font-bold" data-id="element-182">{testimonio.name}</h4>
                  <p className="text-xs text-white/60 uppercase tracking-wider" data-id="element-183">
                    {testimonio.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}